export default (text: string, num: number) => {
    switch (`${num}`[`${num}`.length - 1]) {
      case '1':
        return `${text}st`;
        break;
      case '2':
        return `${text}nd`;
        break;
      case '3':
        return `${text}rd`;
        break;
      default:
        return `${text}th`;
    }
  }